let settingsSessionId: number | undefined;

export function setSettingsSessionId(id: number) {
  settingsSessionId = id;
}

export function clearSettingsSessionId() {
  settingsSessionId = undefined;
}

export function getSettingsSessionProps(): { settingsSessionId?: number } {
  return settingsSessionId === undefined ? {} : { settingsSessionId };
}
